export default "__VITE_ASSET__BwwpBDXW__"